export default "__VITE_ASSET__Cc_xd4Xl__"